import React, { useEffect } from "react";
import logo from "../assets/ffxnobg.png";

const ShippingDelivery = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="w-full h-[80px] flex items-center justify-center bg-dark-blue shadow-md">
        <img
          src={logo}
          alt="FutureForgeX"
          className="w-[140px] h-auto object-contain rounded-lg mr-4"
        />
        <h1 className="text-white text-xl sm:text-2xl font-semibold">
          FUTURE FORGEX PRIVATE LIMITED
        </h1>
      </header>
      <div className="max-w-4xl mx-auto p-6 text-gray-800">
        <h1 className="text-3xl font-semibold mb-6 text-center">SHIPPING & DELIVERY POLICY</h1>
        <p className="mb-6 text-justify">
          <strong>Last updated: [Date]</strong>
        </p>
        <h2 className="text-xl font-semibold mt-6 mb-3">DIGITAL DELIVERY</h2>
        <p className="mb-4 text-justify">
          At FutureForgeX, we specialize in delivering IT and software solutions. All our products and services are delivered digitally via email or through our website/platform.
        </p>
        <ul className="list-disc ml-6 mb-4">
          <li>Upon successful payment, you will receive access to your purchased software/service via email or your account dashboard.</li>
          <li>Delivery is typically instant, but in rare cases, it may take up to 24 hours.</li>
          <li>If you do not receive your product/service within 24 hours, please contact us at <a href="mailto:futureforgexsupport@gmail.com" className="underline">futureforgexsupport@gmail.com</a>.</li>
        </ul>
        <h2 className="text-xl font-semibold mt-6 mb-3">NO PHYSICAL SHIPPING</h2>
        <p className="mb-4 text-justify">
          We do not ship any physical goods. All offerings are digital in nature.
        </p>
        <h2 className="text-xl font-semibold mt-6 mb-3">CONTACT US</h2>
        <p className="mb-2 text-justify">For any questions about our Shipping and Delivery Policy, please contact us at:</p>
        <p className="mb-4 text-justify">Email: <a href="mailto:futureforgexsupport@gmail.com" className="underline">futureforgexsupport@gmail.com</a></p>
        <p className="mb-4 text-justify">Website: <a href="https://www.futureforgex.in" className="underline" target="_blank" rel="noopener noreferrer">www.futureforgex.in</a></p>
        <p className="mb-4 text-justify">Phone: <a href="tel:+918499956365" className="underline">+91 8499956365</a></p>
        <p className="mb-4 text-justify">Address: 14-239, Current colony, B kothakota, Chittoor-517370, Madanapalle, Andhra Pradesh</p>
      </div>
    </div>
  );
};

export default ShippingDelivery; 